module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#photo",
      toString: function () {
        return this.url;
      }
    }